/**
 * debounce — returns a debounced version of `fn` that only runs after `delay` ms have
 * passed without another call. Each call resets the timer, so it fires once the calls
 * "settle". The returned function exposes `.cancel()` to clear any pending run.
 *
 * @param {Function} fn     Function to debounce.
 * @param {number}   delay  Quiet period in milliseconds before `fn` runs (default 200).
 * @returns {Function} debounced function with a `.cancel()` method.
 */
export const debounce = (fn, delay = 200) => {
  let timer = null;

  const debounced = (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, delay);
  };

  debounced.cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return debounced;
};
